import request from "@/utils/request";
import axios from 'axios'
/*  
    @Url指接口链接  @Name指公共方法 
    @Params指URL后面拼接参数 @Data指作为请求主体被发送的数据
*/

// 公共的get接口
let arr = [
    {
        name: "GetAllSelOption",
        URL: "/commonApi/MC6/api/EM/CLZT/GetAllSelOption"
    }, //用车调度-用车申请-所有下拉框数据
    {
        name: "GetPowerCarTreeByStep",
        URL: "/commonApi/MC6/api/User/PowerData/GetPowerCarTreeByStep"
    }, //公司部门车辆
    {
        name: "GetCompanyList",
        URL: "/commonApi/MC6/api/User/PowerData/GetCompanyList"
    },
    { name: "GetCarManList", URL: "/commonApi/MC6/api/EM/CLZT/GetCarManList" }, //用车调度--获取用车人信息
    { name: "CarOutCK", URL: "/commonApi/MC6/api/EM/CLZT/CK" },
    {
        name: "GetDeptTypeList",
        URL: "/commonApi/MC6/api/BasicInfo/BMLX/GetDeptTypeList"
    }, //基础信息-部门信息-部门类型下拉选项
    {
        name: "GetFactoryXL",
        URL: "/commonApi/MC6/api/BasicInfo/Common/GetFactoryXL"
    }
];
function match(name) {
    let URL;
    arr.forEach(item => {
        if (item.name === name) {
            URL = item.URL;
        }
    });
    return URL;
}

// PostData(Url,null||{},null||{})
// 公共的post方法
export function PostData(Url, Params, Data, timeout) {
    return request({
        url: Url,
        method: "post",
        params: Params,
        data: Data,
        timeout: timeout,
    });
}

// getData(Url,null,{})
// getData(null,GetPowerCarTreeByStep,{})

// 公共的get方法
export function GetData(Url, Name, Params, timeout) {
    return request({
        url: Url ? Url : match(Name),
        method: "get",
        params: Params ? Params : null,
        timeout: timeout,
    });
}

// PostData(Url,null||{},null||{})
// 公共的post方法
export function PostDataNoAuthor(Url, Params, Data) {
    return axios({
        url: Url,
        method: "post",
        params: Params,
        data: Data
    });
}

// getData(Url,null,{})
// getData(null,GetPowerCarTreeByStep,{})

// 公共的get方法
export function GetDataNoAuthor(Url, Name, Params) {
    return axios({
        url: Url ? Url : match(Name),
        method: "get",
        params: Params ? Params : null
    });
}
// 获取gps信息
export const fetchGpsData = data =>
    new Promise(resolve => {
        PostData(
            `${StarSoft.SysInfo.V8}MC6/api/Common/FormQuery/GetInternalGpsInfo`,
            null,
            data
        ).then(res => resolve(res.data));
    });